import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// Register web components EARLY - before any React rendering
// This is critical for Safari compatibility when navigating directly to URLs
import './components/WebComponents'
import App from './App'
import 'typeface-roboto'
import * as logger from 'loglevel'
window.logger = logger

// Configure log level from environment, defaulting to 'warn' if unset.
// e.g. REACT_APP_LOG_LEVEL=debug in .env.development
if (process.env.REACT_APP_LOG_LEVEL) {
  logger.setLevel(process.env.REACT_APP_LOG_LEVEL)
}

// Create a root.
const container = document.getElementById('root')
const root = createRoot(container) // Create a root for the container.

// Initial render: Render an element to the root.
root.render(<App />)
